<template>
    <div >
      <back></back>
      <div class="search border-bottom">
        <router-link tag="div" to="/index/search/reset?categories=1">
          <search-fake :placeholder="'搜索付费精品'"></search-fake>
        </router-link>
      </div>
      <div class="border-bottom">
        <div class="tabs">
          <router-link tag="div" to="wk" class="tab" replace >
            <span>微课</span>
          </router-link>
          <router-link tag="div" to="txk" class="tab" replace >
            <span>体系课</span>
          </router-link>
        </div>
      </div>
      <div class="list">
        <router-view></router-view>
      </div>
      <tab></tab>
    </div>
</template>
<script type="text/ecmascript-6">
import Tab from '@/components/tab/tab'
import NavTab from '@/components/base/nav-tab/nav-tab'
import SearchFake from '@/components/base/search/search-fake'
import back from '@/components/base/ui/back.vue'
export default {
  components: {
    SearchFake,
    NavTab,
    Tab,
    back
  },
  data() {
    return {
      active: 'all'
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .list{
    padding-bottom: size(100)
  }
  .fix-top
    position fixed
    left 0
    top 0
    width 100%;
    background #ffffff
    z-index 999
  .search
    padding size(30)
  .tabs
    display table
    width 100%
    height size(90)
    padding 0 size(30)
    .tab
      display table-cell
      vertical-align middle
      text-align center
      width 33.3%
    span
      display inline-block
      line-height size(86)
      font-size size(32)
    .router-link-exact-active
      >span
        font-weight 700
        position relative
        &:after
          content ' '
          display block
          position absolute
          bottom size(12)
          left 50%
          width size(30)
          margin-left size(-15)
          height 3px
          background $color-theme
          border-radius 1.5px
</style>



// WEBPACK FOOTER //
// src/components/jpff/jpff.vue